var exports = {
  "root": "x1cb7f6e3--b5d8ba--root",
  "phone": "x1cb7f6e3--b5d8ba--phone",
  "custom-wrapper": "x1cb7f6e3--b5d8ba--custom-wrapper",
  "adornment": "x1cb7f6e3--b5d8ba--adornment",
  "term-adornment": "x1cb7f6e3--b5d8ba--term-adornment",
};

module.exports = exports;
